// DN-40 (hub-arbitrated v2 contract, adopted 2026-09-02): Sun resolves the returnable population
// itself, AT THE INSTANT OF THE ACT (CU2 steps 2-5, RN18/NR6: no partial reception) -- jupiter no
// longer sends `reportedPartIds`. The request carries only the trip ids, the confirmed date and
// `nokPartIds`, which stays always empty (DECISIÓN PO 2026-09-01: MOS reports every returned part
// as OK, there is no NOK selection UI).
export const buildReturnPayload = (trip, at) => ({
  fabricationOrderId: trip.fabricationOrder?.id,
  jobReferenceId: trip.job?.id,
  at,
  nokPartIds: []
})
